import React from "react";
import { Box, Flex, Image } from "@chakra-ui/react";
import Logo from "../assets/images/drhvac.svg";

const LogoOnlyNav = () => {
  return (
    <Box
      as="nav"
      position="fixed"
      top="0"
      left="0"
      right="0"
      bg="white"
      boxShadow="0px 10px 20px rgba(0, 0, 0, 0.1), 0px 6px 6px rgba(0, 0, 0, 0.1)" // Floating effect
      py={25}
      px={50}
      zIndex="100"
    >
      <Flex justify="center" align="center">
        <Image src={Logo} alt="Logo" height="40px" />
      </Flex>
    </Box>
  );
};

export default LogoOnlyNav;
